/**
 * env
 * 全局的一些状态的处理
 *
 * Created by Samuel on 2023/5/12
 */
import * as _ from 'lodash-es';

// 支持传入 context 以获取当前指定的语言包的语言Id
const LANG2ID = {
	cn: 1,
	tw: 2,
	en: 3,
	es: 4,
	ar: 5,
	fr: 6,
	de: 7,
	it: 8,
	ja: 9,
	ko: 10,
	ru: 11,
};
// LANG2ID 的 key 和 value 互换
const LID2LANG = _.invert(LANG2ID);
let langId = 3;
// 优先检查是否有后端返回的语言信息 && LANG_CODE 在
if (window.LANG_CODE && LID2LANG[window.LANG_CODE]) {
	langId = window.LANG_CODE;
} else {
	const language = navigator.language;
	const langInfoList = language.toLowerCase().split('-');
	if (langInfoList.includes('zh')) {
		if (langInfoList.includes('hant') || langInfoList.includes('tw') || langInfoList.includes('hk')) {
			langId = LANG2ID.tw;
		} else {
			langId = LANG2ID.cn;
		}
	} else if (LANG2ID[langInfoList[0]]) {
		langId = LANG2ID[langInfoList[0]];
	}
}
const language = LID2LANG[langId];

const prd = process.env.NODE_ENV === 'production';
const testDev = process.env.NODE_ENV === 'development' && location.href.includes('test.');
export const test = testDev;
export const lid2LangCode = LID2LANG;
export { langId, language, prd };

export const logify = (...data) => {
	return _.map(data, (d) => {
		// 判断 data 是否为 proxy，如果是，则转换为普通对象
		if (d && d.__isProxy__) {
			return JSON.parse(JSON.stringify(data));
		}
		return d;
	});
};

// 响应式判断的断点
export const MEDIA_MOBILE_MODE = `(max-width: 768px)`;
